import { Button, Flex, Text } from '@mantine/core';
import { closeModal } from '@mantine/modals';
import { ModalWarningContent } from '@shared/ui/modal';
import { useState } from 'react';

export const CANDIDATE_RESUME_DEACTIVATE_MODAL_ID =
  'candidate-resume-deactivate';

type CandidateResumeDeactivateModalContentProps = {
  onConfirm: () => Promise<boolean>;
};

export const CandidateResumeDeactivateModalContent = ({
  onConfirm,
}: CandidateResumeDeactivateModalContentProps) => {
  const [isPending, setIsPending] = useState(false);

  const handleClose = () => {
    closeModal(CANDIDATE_RESUME_DEACTIVATE_MODAL_ID);
  };

  const handleConfirm = async () => {
    setIsPending(true);
    const isUpdated = await onConfirm();
    setIsPending(false);

    if (isUpdated) {
      handleClose();
    }
  };

  return (
    <Flex direction='column'>
      <ModalWarningContent
        message={
          <Text c='primary.7'>
            Деактивация профиля кандидата приведет к тому, что деактивированный
            профиль не будет рассматриваться при подборе кандидатур на вакансии.
            Все равно хотите деактивировать профиль?
          </Text>
        }
        iconAlign='flex-start'
      />

      <Flex pt={12} gap={8}>
        <Button variant='outline' onClick={handleClose} disabled={isPending}>
          Отмена
        </Button>
        <Button
          variant='primary'
          onClick={handleConfirm}
          loading={isPending}
          disabled={isPending}
        >
          Да, деактивировать
        </Button>
      </Flex>
    </Flex>
  );
};
